import { Reveal, Overline } from "@/components/motion";

const STEPS = [
  { num: "01", title: "Zero-cost setup", desc: "We deliver and install a premium bean-to-cup espresso machine at zero capital expenditure to your business." },
  { num: "02", title: "We stock & service", desc: "Freshly roasted beans delivered on schedule, daily self-cleaning cycles and full maintenance included." },
  { num: "03", title: "You choose the charity", desc: "Pick a registered UK charity your team cares about. 22p from every single cup goes directly to them." },
  { num: "04", title: "Track the impact", desc: "A QR code on the machine links to your live location page — cups poured and pounds raised, updated weekly." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-24 sm:py-32 bg-[#F7F5F0]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal><Overline>For hosts</Overline></Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-display font-bold tracking-tight text-[#0B1E17] text-2xl sm:text-3xl lg:text-4xl max-w-2xl leading-tight">
          Four effortless steps to turn your coffee break into a force for good.
        </h2>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.1 + i * 0.08}>
            <div data-testid={`how-step-${s.num}`}
              className="group h-full bg-white rounded-2xl border border-[#E2DDD3] p-7 hover:border-[#1B5E46]/40 hover:-translate-y-1.5 transition-all duration-500 hover:shadow-xl hover:shadow-[#1B5E46]/10">
              <p className="font-mono-brand text-sm font-semibold text-[#D97706]">{s.num}</p>
              <h3 className="mt-4 font-display font-bold text-xl text-[#0B1E17]">{s.title}</h3>
              <p className="mt-3 text-sm text-[#52665E] leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
